import {
  ProductNav,
  ProductNavLink,
  ProductNavList,
  ProductNavLogo,
} from 'eds-product-experience-ux';
import { useMatch } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import elaLogo from '@/assets/images/elaLogo.png';
import elaMobileLogo from '@/assets/images/elaMobileLogo.png';

export function StudentNavigation() {
  const isELAPath = useMatch('/explore-ela/*');
  const isELAHomepage = useMatch('/explore-ela');
  const isELAHistoryPage = useMatch('/explore-ela/recent');
  const shouldUseTransparentBg = Boolean(isELAHomepage || isELAHistoryPage);

  const isMobile = useMediaQuery({ query: '(max-width: 639px)' });

  const Logo = isMobile ? elaMobileLogo : elaLogo;

  return isELAPath ? (
    <ProductNav className="grow" isDark={shouldUseTransparentBg}>
      <ProductNavLogo src={Logo} alt="Explore e-l-a" href="/explore-ela" />
      <ProductNavList>
        <ProductNavLink to="explore-ela/recent">
          My Story History
        </ProductNavLink>
      </ProductNavList>
    </ProductNav>
  ) : null;
}
